export const PARTNERS_BULK_BATCH_SIZE = 50;

export const chunkArray = <T>(items: T[], size: number): T[][] => {
  if (!items?.length || size <= 0) {
    return [];
  }

  const chunks: T[][] = [];

  for (let index = 0; index < items.length; index += size) {
    chunks.push(items.slice(index, index + size));
  }

  return chunks;
};
